import { useSelector } from 'react-redux'
import {
  selectTransferTargetAddressHex,
  selectTransferTargetAsset,
  selectTransferTargetChain,
  selectTransferTargetParsedTokenAccount
} from '../store/selectors'
import { hexToNativeString } from '@alephium/wormhole-sdk'
import { useMemo } from 'react'

const useTargetInfo = () => {
  const targetChain = useSelector(selectTransferTargetChain)
  const targetAddressHex = useSelector(selectTransferTargetAddressHex)
  const targetAsset = useSelector(selectTransferTargetAsset)
  const targetParsedTokenAccount = useSelector(selectTransferTargetParsedTokenAccount)
  const tokenName = targetParsedTokenAccount?.name
  const symbol = targetParsedTokenAccount?.symbol
  const logo = targetParsedTokenAccount?.logo
  const readableTargetAddress = hexToNativeString(targetAddressHex, targetChain) || ''
  return useMemo(
    () => ({
      targetChain,
      targetAsset,
      tokenName,
      symbol,
      logo,
      readableTargetAddress
    }),
    [targetChain, targetAsset, tokenName, symbol, logo, readableTargetAddress]
  )
}

export default useTargetInfo
